import React from 'react';

const ChatEvaluation = props => (
  <>
    <p className="chat-evaluation-title">Como foi seu atendimento?</p>
    <div className="chat-evaluation">
      <div className="chat-evaluation-button" onClick={() => props.handleEvaluation(1)}>
        Ruim
      </div>
      <div className="chat-evaluation-button" onClick={() => props.handleEvaluation(2)}>
        Regular
      </div>
      <div className="chat-evaluation-button" onClick={() => props.handleEvaluation(3)}>
        Bom
      </div>
    </div>
  </>
);

export default ChatEvaluation;